"use client";
import React from "react";
import Link from "next/link";
import Image from "next/image";
import styles from "./Logo.module.css";

function Logo({
  mobileAlignment = "left",
  isFooter,
}: {
  mobileAlignment?: "left" | "right" | "center";
  isFooter: boolean;
}) {
  // Construct the image URL without string interpolation
  const imageUrl = isFooter ? "/images/logo-white.webp" : "/images/logo-blue.svg";
  
  return (
    <Link
      href="/"
      className={styles.wrapper}
      data-mobile-alignment={mobileAlignment}
    >
      <Image
        src={imageUrl}
        alt="logo"
        width={128}
        height={70}
        priority
      />
    </Link>
  );
}

export default Logo;
